import type { ValidatorResult } from 'ember-changeset-validations';
import { validateFormat } from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const MessageValidation = {
  content: [
    customMessageValidator(
      'message_content',
      validateFormat({
        regex: /\{[^}]+\}/,
        inverse: true,
      }),
    ),
    customMessageValidator(
      'sms_message_length',
      function (
        key: string,
        newValue: unknown,
        oldValue: unknown,
        changes: Record<string, unknown>,
        content: Record<string, unknown>,
      ): ValidatorResult {
        if ((changes['type'] || content['type']) === 'sms') {
          if (newValue && (newValue as string).length > 160) {
            return false;
          }
        }

        return true;
      },
    ),
  ],
  image: validateFormat({ allowBlank: true, type: 'url' }),
};
